import { render, staticRenderFns } from "./ActivityCouponModule.vue?vue&type=template&id=1f747c4e&scoped=true"
import script from "./ActivityCouponModule.vue?vue&type=script&lang=js"
export * from "./ActivityCouponModule.vue?vue&type=script&lang=js"
import style0 from "./ActivityCouponModule.vue?vue&type=style&index=0&id=1f747c4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f747c4e",
  null
  
)

export default component.exports